<template>
  <div class="chat">
    <div class="row">
      <div class="col-12 col-sm-12 text-center text-sm-start">
        <span class="d-none d-sm-block">
          <page-title v-if="selectedChild" :title="'Berichten ' + selectedChild.full_name" icon="chat"></page-title>
          <page-title v-else :title="'Berichten'" icon="chat"></page-title>
        </span>
        <span class="d-block d-sm-none">
          <page-title :title="'Berichten'" icon="chat"></page-title>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-5">
        <span v-if="loadingCount === false">
          <child-list
              class="d-none d-sm-block"
              :filteredChildren="children"
              :unreadMessagesCount="unreadChatMessageCountPerChild"
          />
          <child-list-select class="d-block d-sm-none" :filteredChildren="children"></child-list-select>
        </span>
      </div>
      <div class="col-12 col-sm-7" style="padding-left: 0">
        <div id="messages" class="scrollable" style="height: 50vh; background: white;">
          <div  style="padding: 20px; padding-left: 30px; padding-right: 30px; padding-bottom: 0;">
            <div v-if="loading === true">
              <p>Laden...</p>
            </div>
            <div v-else-if="messages && messages.length < 1">
              <p>
                Geen berichten
              </p>
            </div>
            <div id="messages" v-else-if="messages">
              <div v-bind:key="message.id" v-for="message in messages" class="row">
                <div v-if="message.showDate === true" class="ms-auto me-auto col-6 col-sm-6 text-center">
                  <br>
                  <p>
                    {{ formatMessageDateLong(message.created_at) }}
                  </p>
                </div>
                <div v-if="message.enterd_by === 0" class="ms-auto col-10 col-sm-7">
                  <p class="alert alert-orange text-style">
                    {{ message.text }}
                  </p>
                </div>
                <div v-else-if="message.enterd_by === 1" class="me-auto col-10 col-sm-7">
                  <p class="alert alert-grey text-style">
                    {{ message.text }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="background: white">
          <div v-if="loading === false">
            <div class="d-grid gap-2 p-3">
              <textarea-plus-two
                  v-model="message"
                  placeholder="Nieuw bericht..."
              />
              <button v-on:click="sendMessage()" class="btn btn-info" style="margin-top: 20px">Verzend</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import ChildList from '@/components/Child-List'
import ChildListSelect from '@/components/Child-List-Select'
import TextareaPlusTwo from '@/components/Textarea-Plus-Two'
export default {
  name: 'chat',
  components: {
    PageTitle,
    ChildList,
    ChildListSelect,
    TextareaPlusTwo
  },
  watch: {
    selectedChild (child) {
      this.$store.dispatch('updateHasUnreadChatMessages')
      this.selectChild(child)
    },
    unreadChatMessageCountPerChild() {
      if (this.selectedChildHasUnreadMessages() === true) {
        this.loadMessagesForChild(this.selectedChild)
      }
    }
  },
  computed: {
    selectedGroupsQueryString () {
      return this.$store.getters.selectedGroupsQueryString
    },
    children () {
      return this.$store.getters.children
    },
    unreadChatMessageCountPerChild () {
      return this.$store.getters.unreadChatMessageCountPerChild
    }
  },
  data () {
    return {
      interval: null,
      loading: false,
      loadingCount: false,
      messages: null,
      message: null
    }
  },
  created () {
    if (this.selectedChild) {
      this.selectChild(this.selectedChild)
    }

    clearInterval(this.interval)
    this.loadUnreadMessagesCountForAllChildren()
    var app = this
    this.interval = setInterval(function () {
      app.loadUnreadMessagesCountForAllChildren()
    }, 30000)
  },
  updated () {
    var container = this.$el.querySelector('#messages')
    container.scrollTop = container.scrollHeight
  },
  unmounted () {
    clearInterval(this.interval)
  },
  methods: {
    selectedChildHasUnreadMessages () {
      if (!Array.isArray(this.unreadChatMessageCountPerChild)) {
        return false
      }
      if (this.selectedChild === null) {
        return false
      }
      for (var i = 0; i < this.unreadChatMessageCountPerChild.length; i++) {
        if (parseInt(this.unreadChatMessageCountPerChild[i].child_id) !== parseInt(this.selectedChild.id)) {
          continue
        }
        if (this.unreadChatMessageCountPerChild[i].unread_messages > 0) {
          return true
        }
      }
      return false
    },
    prepareMessages (messages) {
      var previousDate = false
      var app = this
      messages.forEach(function (part, i, messageArray) {
        var date = app.$moment(messageArray[i].created_at).format('DD-MM-YYYY HH')
        if (date !== previousDate) {
          messageArray[i].showDate = true
        } else {
          messageArray[i].showDate = false
        }
        previousDate = date
      })
      return messages
    },
    selectChild (child) {
      this.loading = true
      this.loadMessagesForChild(child)
      this.$store.dispatch('updateHasUnreadChatMessages')
      this.loadUnreadMessagesCountForAllChildren()
    },
    loadUnreadMessagesCountForAllChildren () {
      this.$store.dispatch('updateUnreadChatMessageCountPerChild')
    },
    loadMessagesForChild (child) {
      this.$request.get('/messages?id_child=' + child.id)
      .then((response) => {
        this.loading = false
        if (response.data) {
          this.messages = this.prepareMessages(response.data)
        } else {
          this.messages = []
        }
        this.$store.dispatch('updateHasUnreadChatMessages')
        this.loadUnreadMessagesCountForAllChildren()
      }).catch(() => {
        this.messages = []
      })
    },
    sendMessage () {
      this.loading = true
      this.$request.post('/messages', {
        child_id: this.selectedChild.id,
        text: this.message,
        created_by: 1
      }).then(() => {
        this.loading = false
        this.message = null
        this.selectChild(this.selectedChild)
      });
    }
  }
}
</script>

<style scoped>
  .alert {
    border-radius: .75rem;
    margin-bottom: 10px;
  }
  .alert-grey {
    background: #dedede;
  }
  .alert-orange {
    background: #fb853d;
    color: white;
  }
  .text-style{
      white-space: pre-line;
  }
</style>
